import { CaretDown, Paperclip, Warning } from '@phosphor-icons/react';
import AttachmentUploader from '../UI/AttachmentUploader';
import PendingAttachmentUploader from './PendingAttachmentUploader';

/**
 * AttachmentSection - Collapsible section for managing attachments
 * Shows AttachmentUploader for existing events, PendingAttachmentUploader for new events
 */
export default function AttachmentSection({
  isEditing,
  isExpanded,
  onToggle,
  // For existing events
  attachments,
  onAttachmentsChange,
  eventId,
  loadingAttachments,
  // For new events
  pendingAttachments,
  onPendingChange,
  tempId,
  // Common
  disabled,
  uploadError,
}) {
  const attachmentCount = isEditing ? attachments.length : pendingAttachments.length;

  return (
    <div 
      className="rounded-sm overflow-hidden"
      style={{ border: '1px solid var(--color-border-subtle)' }}
    >
      <button
        type="button"
        onClick={onToggle}
        className="w-full flex items-center justify-between p-3 transition-colors"
        style={{ 
          backgroundColor: 'var(--color-bg-surface)',
          color: 'var(--color-text-secondary)',
        }}
      >
        <span className="text-sm font-medium flex items-center gap-2">
          <Paperclip size={16} />
          Attachments
          {attachmentCount > 0 && (
            <span 
              className="px-2 py-0.5 rounded-full text-xs"
              style={{ 
                backgroundColor: 'var(--color-brand-primary)',
                color: 'white',
              }}
            >
              {attachmentCount}
            </span>
          )}
        </span>
        <CaretDown 
          size={16} 
          weight="bold"
          className={`transition-transform duration-200 ${isExpanded ? 'rotate-180' : ''}`}
        />
      </button>
      
      {isExpanded && (
        <div className="p-3" style={{ backgroundColor: 'var(--color-bg-canvas)' }}>
          {isEditing ? (
            // Existing event: show server attachments
            loadingAttachments ? (
              <div className="text-center py-4">
                <span className="text-sm" style={{ color: 'var(--color-text-muted)' }}>
                  Loading attachments...
                </span>
              </div>
            ) : (
              <AttachmentUploader
                attachments={attachments}
                onAttachmentsChange={onAttachmentsChange}
                eventId={eventId}
                disabled={disabled}
              />
            )
          ) : (
            // New event: show pending attachments uploader
            <PendingAttachmentUploader
              pendingAttachments={pendingAttachments}
              onPendingChange={onPendingChange}
              tempId={tempId}
              disabled={disabled}
            />
          )}
        </div>
      )}
      
      {/* Upload error message */}
      {uploadError && (
        <div 
          className="p-3 text-sm flex items-start gap-2"
          style={{ 
            backgroundColor: 'rgba(193, 96, 92, 0.1)',
            color: 'var(--color-status-error)',
          }}
        >
          <Warning size={18} weight="fill" className="flex-shrink-0 mt-0.5" />
          <span>{uploadError}</span>
        </div>
      )}
    </div>
  );
}
